export const PERMS = {
    READ: 'report_vehicle_kilometers_total.read',
    UPDATE: 'report_vehicle_kilometers_total.update',
    DELETE: 'report_vehicle_kilometers_total.delete',
    CREATE: 'report_vehicle_kilometers_total.create',
    EXPORT: 'report_vehicle_kilometers_total.export',
}
